import { Component } from 'react';
import ConfigureHTTPHeaders from '../ConfigureHTTPHeaders';

class ProtectedComponent extends Component {
  constructor(props) {
    super(props);
    let currentUser = JSON.parse(localStorage.getItem('user'));
    this.state = {
      user: currentUser,
      isLoading: true
    };
  }

  componentDidMount() {
    this.checkAuthentication();

    window.addEventListener('storage', e => {
      if (e.url.split('/')[3] === 'sign-out') {
        window.location.href = '/sign-in';
      } else if (e.url.split('/')[3] === 'sign-in') {
        window.location.href = '/';
      }
    });
  }

  checkAuthentication = () => {
    const currentUser = JSON.parse(localStorage.getItem('user'));

    if (!currentUser) {
      window.location.href = '/sign-in';
    } else {
      this.setState({
        user: currentUser,
        isLoading: false
      });
      ConfigureHTTPHeaders();
    }
  };

  renderLoading() {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '50vh',
          fontSize: '16px',
          color: '#666'
        }}
      >
        Loading...
      </div>
    );
  }

  render() {
    if (this.state.isLoading) {
      return this.renderLoading();
    }

    // This will be overridden by child components
    return null;
  }
}

export default ProtectedComponent;
